import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=2a614cfa&scoped=true&"
import script from "./pending.vue?vue&type=script&lang=js&"
export * from "./pending.vue?vue&type=script&lang=js&"
import style0 from "./pending.vue?vue&type=style&index=0&id=2a614cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a614cfa",
  null
  
)

export default component.exports